var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstruction3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M41.8267 5.1665H20.1758C12.3225 5.1665 7.75 9.76484 7.75 17.644V44.3298C7.75 52.3382 12.3225 56.8332 20.1758 56.8332H41.8267C49.8067 56.8332 54.25 52.3382 54.25 44.3298V17.644C54.25 9.76484 49.8067 5.1665 41.8267 5.1665Z",
    fill: "#136BFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8734 17.1792V17.205C19.76 17.205 18.8584 18.1092 18.8584 19.22C18.8584 20.3309 19.76 21.235 20.8734 21.235H28.595C29.7084 21.235 30.6126 20.3309 30.6126 19.1916C30.6126 18.0834 29.7084 17.1792 28.595 17.1792H20.8734ZM41.1267 32.9117H20.8734C19.76 32.9117 18.8584 32.0075 18.8584 30.8967C18.8584 29.7858 19.76 28.8791 20.8734 28.8791H41.1267C42.2376 28.8791 43.1417 29.7858 43.1417 30.8967C43.1417 32.0075 42.2376 32.9117 41.1267 32.9117ZM41.1268 44.7175H20.8735C20.0985 44.8209 19.3493 44.4334 18.936 43.7875C18.5226 43.1159 18.5226 42.2634 18.936 41.6175C19.3493 40.9459 20.0985 40.5842 20.8735 40.6617H41.1268C42.1576 40.765 42.9351 41.6434 42.9351 42.7025C42.9351 43.7333 42.1576 44.6142 41.1268 44.7175Z",
    fill: "#136BFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstruction3);
export default __webpack_public_path__ + "static/media/instruction-3.33484a17ba52d022a1af1128ab5f4141.svg";
export { ForwardRef as ReactComponent };